exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2YxKL{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._2YxKL:hover{opacity:.7}._3eQS8{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._2Cmt3{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;height:25px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._2U6I4{font-size:12px}div[data-hook=player-container][data-in-full-screen=true] ._2U6I4{font-size:14px}.KXIQc{margin-left:5px}.KXIQc:before{margin-right:4px;content:\"/\"}.MN2Gc ._1oGmy,.MN2Gc .KXIQc{display:none}", ""]);

// exports
exports.locals = {
	"controlButton": "_2YxKL",
	"hidden": "_3eQS8",
	"timeWrapper": "_2Cmt3",
	"time": "_2U6I4",
	"duration": "KXIQc",
	"liveMode": "MN2Gc",
	"separator": "_1oGmy"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--9-1!../node_modules/postcss-loader/lib??ref--9-2!../node_modules/sass-loader/lib/loader.js??ref--9-3!./default-modules/ui/controls/time/time.scss
// module id = 226
// module chunks = 0 1 2 3 4